<template lang="pug">
  #app
    router-view.router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
@import './stylus/main.styl'
.views-container
  width 100vw
  min-height 100vh
  display flex
  flex-direction row
.swal2-container
  background-color rgba(0, 0, 0, 0.5)
</style>



// WEBPACK FOOTER //
// src/App.vue